import CryptoJS from 'crypto-js';
import { camelCase } from 'lodash';

export const encryptData = (data: string): any => {
  if (data) {
    const key = CryptoJS.enc.Utf8.parse('$%C*F-JaNdRgUkXp'); // Use a 16-byte key for AES-128
    const iv = CryptoJS.enc.Utf8.parse('G+KbPeShVmYq3t6v');
    const encrypted = CryptoJS.AES.encrypt(data, key, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return encrypted.toString();
  }
  return data;
};

export const decryptData = (encryptedData: string): string => {
  const key = CryptoJS.enc.Utf8.parse('$%C*F-JaNdRgUkXp'); // Use a 16-byte key for AES-128
  const iv = CryptoJS.enc.Utf8.parse('G+KbPeShVmYq3t6v');
  const decrypted = CryptoJS.AES.decrypt(encryptedData, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
  return decryptedText;
};

export const convertKeysToCamelCase = (obj: any): any => {
  if (Array.isArray(obj)) {
    return obj.map((item: any): any => convertKeysToCamelCase(item)); // Recursively handle arrays
  } else if (obj !== null && typeof obj === 'object') {
    return Object.keys(obj).reduce((result: any, key: any): any => {
      const camelKey = camelCase(key); // Convert key to camelCase
      result[camelKey] = convertKeysToCamelCase(obj[key]); // Recursively apply for nested objects/arrays
      return result;
    }, {} as any);
  }
  return obj;
};
